module.exports = __webpack_public_path__ + "static/media/close-small.138eacea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/close-small.svg
// module id = 992
// module chunks = 0